import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {BaseEffect} from './base.effect';
import {LoadMySubscriptionsFailAction} from '../actions/my-subscriptions';
import {ArrayResponse, LoadMyClientsFailAction, myClientsActionTypes, SendBackResult} from '..';
import {Order} from '../../order/models/order';
import {LoadMyOrdersAction, LoadMyOrdersSuccessAction, myOrdersActionTypes} from '../actions/my-orders';
import {MyOrdersService} from '../services/my-orders.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class MyOrdersEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(myOrdersActionTypes.LOAD),
    debug('Load My orders list action received.'),
    map((action: LoadMyOrdersAction) => Object.assign({}, { $page: 1, $length: 200 }, { clientName: action.payload })),
    switchMap((filterD) => this.myOrdersService.getList(filterD).pipe(
      map((payload: SendBackResult<ArrayResponse<Order>>) => new LoadMyOrdersSuccessAction(payload.data)),
      catchError(res => this.catchResponseError(res)))))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(myClientsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving My orders list.'),
    map((action: LoadMyClientsFailAction) => error(this.translation.translate('ORDERS_LOAD_ERROR') + '  ' + action.payload,
      this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              router: Router,
              private myOrdersService: MyOrdersService) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadMySubscriptionsFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadMySubscriptionsFailAction(response['error'].message);
  }
}
